// Module
var code = "<md-toast class=\"email-toast\"><span class=\"md-toast-text\" flex><span class=\"toast-head\">Preferences Saved</span><br><span>Your email settings have been saved.</span></span></md-toast>";
// Exports
module.exports = code;